import { ScrollArea, SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton({ loader }: { loader?: React.ReactNode }) {
  return (
    <div className="flex h-full flex-col">
      <div className="border-action-hovered bg-surface-lowest sticky top-0 z-1 flex h-[72px] shrink-0 items-center gap-8 border-b px-6">
        <div className="flex flex-col gap-0.5">
          <SkeletonBlock className="h-4 w-[70px]" />
          <SkeletonBlock className="h-5 w-[130px]" />
        </div>
        <div className="flex flex-col gap-0.5">
          <SkeletonBlock className="h-4 w-[90px]" />
          <SkeletonBlock className="h-5 w-[130px]" />
        </div>
        <div className="flex flex-col gap-0.5">
          <SkeletonBlock className="h-4 w-[100px]" />
          <SkeletonBlock className="h-5 w-[130px]" />
        </div>
      </div>
      <ScrollArea className="flex flex-col gap-1">
        <div className="px-6 py-4">
          <SkeletonBlock className="h-[30px] w-[200px]" />
        </div>
        {loader}
      </ScrollArea>
    </div>
  )
}
